import axios from "axios";
import { authHeader } from './utils'
import {API_URL} from '../config'


export const getActivityService = async (id) => {
  try {
    let options = {
      headers: {
        "content-type": "application/json",
        ...authHeader()
      },
    };
    const response = await axios.get(
      `${API_URL}/activities/getOneUser/${id}`,
      options
    );
    return response.data;
  } catch (e) {
    return e;
  }
};




